import { borderRadius } from '@10d/tend-ui-styling';
import styled from 'styled-components';

const Root = styled.li `
  box-sizing: border-box;
  list-style: none;
  margin: 0;

  display: flex;
  align-items: center;
  padding: 14px 16px;
  background-color: ${props => props.theme.colors.gray0};

  &:not(:last-child):not(:has(+ .tend-ui-stack-navigation-item-group)) {
    border-bottom: 1px solid ${props => props.theme.colors.gray100};
  }

  ${borderRadius};
`;

export { Root };
